import { Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import { Transition } from 'react-transition-group';

import { AvailableLocale } from '../../shared/intl/types';
import { Overlay } from '../Modal/Overlay';

import { Menu } from './Menu';

type Props = {
    locale: AvailableLocale;
    opened: boolean;
    onClose: () => void;
    username: string;
};

export class MenuWithTransition extends Component<Props> {
    private nodeRef = createRef<HTMLDivElement>();

    render(): JSX.Element | null | false {
        const { opened, username, onClose, locale } = this.props;
        return (
            typeof document !== 'undefined' &&
            document.getElementById('app-container') &&
            ReactDOM.createPortal(
                <Transition
                    in={opened}
                    timeout={{
                        enter: 0,
                        exit: 300,
                    }}
                    mountOnEnter
                    unmountOnExit
                    nodeRef={this.nodeRef}
                >
                    {(status) => (
                        <div ref={this.nodeRef}>
                            <Overlay status={status}>
                                <Menu
                                    status={status}
                                    onClose={onClose}
                                    username={username}
                                    locale={locale}
                                    opened={opened}
                                />
                            </Overlay>
                        </div>
                    )}
                </Transition>,
                document.getElementById('app-container') as Element,
            )
        );
    }
}
